import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaTipoVinculacion } from '../_models/alerta-tipo-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class AlertaTipoVinculacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alertasTiposVinculaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AlertaTipoVinculacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( `${this.rutServicio}/enabled` ).pipe( map( res => res as AlertaTipoVinculacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( `${this.rutServicio}/${id}` ).pipe( map( res => res as AlertaTipoVinculacion ) );
  }

  obtenerPorIdAlerta( id: string ) {
    return this.httClient.get( `${this.rutServicio}/alerta/${id}` ).pipe( map( res => res as AlertaTipoVinculacion[] ) );
  }

  crear( regCrear: AlertaTipoVinculacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as AlertaTipoVinculacion ) );
  }

  actualizar( regActualizar: AlertaTipoVinculacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( registros: AlertaTipoVinculacion[] ) {
    registros.forEach( r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado() );
    return this.httClient.post( `${this.rutServicio}/bulk`, registros ).pipe( map( res => res as any ) );
  }
}
